import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-6',
    content: 'flex flex-col gap-4',
    image: 'mx-auto max-w-90',
    title: 'text-xl leading-[1.2] tracking-[0.08em] uppercase',
    heading: 'font-bold',
    text: 'font-extralight',
    description:
      'text-base leading-[1.2] font-light tracking-[0.06em] md:text-lg lg:mb-5',
    listTitle: 'text-lg leading-[1.3] font-semibold tracking-[0.06em]',
    list: 'flex list-none flex-col gap-2 md:gap-3',
    listItem:
      'relative pl-4 text-base leading-[1.3] font-light tracking-[0.06em] before:absolute before:top-1/2 before:left-0 before:size-[4px] before:-translate-y-1/2 before:rounded-full before:bg-current before:content-[""] md:text-lg [&_sup]:text-[10px] md:[&_sup]:text-xs',
    price: 'items-baseline text-2xl leading-[1.3]',
    priceValue: 'font-(family-name:--font-source-serif-4)',
    oldPrice: 'text-lg leading-[1.3]',
    buttons: 'flex gap-3 lg:pb-8',
    button:
      'flex-center h-12 cursor-pointer border border-[#24233D] px-6 text-sm leading-[1.3] font-semibold tracking-[0.04em] uppercase transition-colors duration-300 max-md:w-full md:min-w-[140px]'
  },
  variants: {
    variant: {
      default: {
        base: 'z-1 w-full max-w-110 md:gap-10',
        content: 'md:gap-6',
        title: 'md:text-[28px]',
        text: 'block'
      },
      secondary: {
        base: 'max-w-[495px] items-center text-center md:gap-0',
        content: 'md:gap-0',
        image: 'mx-auto mb-2 max-lg:max-w-[295px] lg:mb-8',
        title: 'md:mb-3 md:text-2xl',
        price: 'max-lg:hidden lg:mb-8'
      }
    },
    color: {
      default: {
        button:
          'bg-[#24233D] text-white hover:bg-transparent hover:text-[#24233D]'
      },
      secondary: {
        button:
          'bg-transparent text-[#24233D] hover:bg-[#24233D] hover:text-white'
      }
    }
  },
  compoundVariants: [
    {
      variant: 'secondary',
      color: 'default',
      className: {
        button: 'max-lg:hidden'
      }
    },
    {
      variant: 'secondary',
      color: 'secondary',
      className: {
        button: 'max-lg:min-w-40'
      }
    }
  ]
});
